export default "__VITE_ASSET__f9a77503__"